import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faFileAlt, faBoxes, faSitemap, faTrafficLight, faCalendarDay } from '@fortawesome/free-solid-svg-icons';

const MiniDashboardCrossedParts = ({
    countEntryPoints,
    countLicenses,
    countPedimentos,
    countTipoPedimento,
    countTrafficReferences,
    averageDaysBetweenInvoices
}) => {
    return (
        <div className="bg-white shadow rounded-lg p-3 w-full mb-4">
            <div className="grid grid-cols-6 divide-x divide-gray-200 text-center">
                <div className="py-2">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="text-blue-600 text-2xl mb-1" />
                    <p className="text-sm text-gray-600">Entry Points</p>
                    <p className="text-lg font-semibold text-gray-800">{countEntryPoints}</p>
                </div>
                <div className="py-2">
                    <FontAwesomeIcon icon={faBoxes} className="text-blue-600 text-2xl mb-1" />
                    <p className="text-sm text-gray-600">Licenses</p>
                    <p className="text-lg font-semibold text-gray-800">{countLicenses}</p>
                </div>
                <div className="py-2">
                    <FontAwesomeIcon icon={faFileAlt} className="text-blue-600 text-2xl mb-1" />
                    <p className="text-sm text-gray-600">Pedimentos</p>
                    <p className="text-lg font-semibold text-gray-800">{countPedimentos}</p>
                </div>
                <div className="py-2">
                    <FontAwesomeIcon icon={faSitemap} className="text-blue-600 text-2xl mb-1" />
                    <p className="text-sm text-gray-600">Tipo Pedimento</p>
                    <p className="text-lg font-semibold text-gray-800">{countTipoPedimento}</p>
                </div>
                <div className="py-2">
                    <FontAwesomeIcon icon={faTrafficLight} className="text-blue-600 text-2xl mb-1" />
                    <p className="text-sm text-gray-600">Traffic References</p>
                    <p className="text-lg font-semibold text-gray-800">{countTrafficReferences}</p>
                </div>
                <div className="py-2">
                    <FontAwesomeIcon icon={faCalendarDay} className="text-blue-600 text-2xl mb-1" />
                    <p className="text-sm text-gray-600">Avg. Days Between</p>
                    <div className="text-lg font-semibold text-gray-800">{averageDaysBetweenInvoices.toFixed(2)}</div>
                </div>
            </div>
        </div>
    );
};

export default MiniDashboardCrossedParts;
